<template>
  <div class="page">
    <div class="search-wrap">
      <van-search
        v-model="value"
        placeholder="输入标题/大咖搜索"
        @search="onSearch"
        @input="onSearch"
      >
      </van-search>
    </div>
    <div class="content-wrap">
      <van-list
        v-model="loading"
        :finished="pageEnd"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <DianJinItem
          v-for="(item, index) in dianJinList"
          :key="index"
          :couponNo="couponNo"
          :dianJinItemData="item"
        ></DianJinItem>
      </van-list>
    </div>
  </div>
</template>
<script>
import { reactive, onMounted, toRefs } from '@vue/composition-api'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { List, Search } from 'vant'
import DianJinItem from '../../components/DianJinItem/DianJinItem.vue'
import api from '../../api/api'
import { appInfo } from '@em/ym'
dayjs.extend(isBetween)

export default {
  name: 'UnlockGold',
  components: {
    DianJinItem,
    'van-search': Search,
    'van-list': List
  },
  setup() {
    const couponNo = appInfo.getParam('couponNo')

    const state = reactive({
      viewState: '',
      dianJinList: [],
      value: '',
      loading: false,
      pageEnd: false,
      popupVisible: false
    })

    onMounted(() => {
      //   lookDianJinData()
    })

    async function lookDianJinData(isRest) {
      if (isRest) {
        state.viewState = ''
        state.pageEnd = false
        state.dianJinList = []
      }
      state.loading = true
      const { detail, result } = await api.course.getDianJinList(
        {
          direction: state.viewState ? 2 : 0,
          // channel: 1,
          keyword: state.value,
          onlyDenied: true // 只显示未解锁的
        },
        state.viewState
      )
      if (result.code === 0) {
        if (isRest) {
          state.dianJinList = detail.list
        } else {
          state.dianJinList = state.dianJinList.concat(detail.list)
        }
        state.pageEnd = detail.end
        state.viewState = result.viewState
        state.loading = false
      }
    }
    function onSearch() {
      console.log('onSearch', state.value)
      lookDianJinData(true)
    }
    function onLoad() {
      lookDianJinData()
    }

    return {
      ...toRefs(state),
      onSearch,
      dayjs,
      onLoad,
      couponNo
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .search-wrap {
    flex: none;
    .van-search {
      padding: 10px 30px;
      border-radius: 4px;
      ::v-deep {
        .van-search__content {
          border-radius: 40px;
        }
      }
    }
  }
  .content-wrap {
    flex: auto;
    overflow-y: auto;
    padding: 0 30px;
    margin-top: 20px;
  }
}
</style>
